import { Star, Quote } from "lucide-react";
import { TESTIMONIALS } from "@/lib/siteConfig";

export default function Testimonials() {
  return (
    <section data-testid="testimonials-section" className="bg-[#F3F4F6] py-20 sm:py-28 reveal">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-14">
          <div>
            <div className="text-xs tracking-[0.25em] uppercase font-bold text-red-600 mb-4">
              — Ils nous ont appelés
            </div>
            <h2 className="font-display font-black tracking-tighter text-4xl sm:text-5xl lg:text-6xl uppercase leading-[0.95] max-w-2xl">
              1 200+ clients<br />nous recommandent.
            </h2>
          </div>
          <div className="flex items-center gap-3">
            <div className="flex">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="w-5 h-5 fill-amber-500 text-amber-500" />
              ))}
            </div>
            <span className="font-display font-bold">4,9/5 · Avis vérifiés</span>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-5">
          {TESTIMONIALS.map((t, i) => (
            <div
              key={i}
              data-testid={`testimonial-${i}`}
              className="bg-white border border-black/10 p-7 flex flex-col gap-5 hover:-translate-y-1 transition-transform relative"
            >
              {/* City badge - top right */}
              <div className="absolute -top-3 right-5 bg-red-600 text-white px-3 py-1.5 text-[10px] uppercase tracking-[0.2em] font-bold flex items-center gap-1.5">
                <span className="w-1.5 h-1.5 bg-white rounded-full" />
                {t.city}
              </div>

              <Quote className="w-8 h-8 text-red-600" strokeWidth={2} />
              <p className="text-slate-700 leading-relaxed">
                « {t.text} »
              </p>
              <div className="mt-auto pt-4 border-t border-black/10 flex items-center justify-between">
                <div>
                  <div className="font-display font-bold text-[#0A0A0A]">{t.name}</div>
                  <div className="text-xs text-slate-500 uppercase tracking-[0.1em] flex items-center gap-1.5 mt-1">
                    <span className="w-1.5 h-1.5 bg-green-500 rounded-full" />
                    Avis authentifié
                  </div>
                </div>
                <div className="flex">
                  {[...Array(t.rating)].map((_, k) => (
                    <Star key={k} className="w-4 h-4 fill-amber-500 text-amber-500" />
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
